import React from 'react';

import { LaunchParamsContext } from './launchParamsContext';
import Charts from './components/Charts';
import { Main } from './Main';
import { Route, Routes } from 'react-router';
import NewExpense from './components/NewExpense';
import Detail from './components/Detail';
import { useStartAppParams } from './components/useStartAppParams';

import eruda from 'eruda';
if (process.env.NODE_ENV === 'development') {
  eruda.init();
}

function App() {
  const lp = React.useContext(LaunchParamsContext);
  const startApp = useStartAppParams();

  const component = React.useMemo(() => {
    if (!lp?.tgWebAppStartParam) {
      return <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/charts/custom" element={<Charts/>} />
        <Route path="/new-expense" element={<NewExpense />} />
        <Route path="/expense/:id" element={<Detail />} />
      </Routes>
    }
    
    if (startApp?.command === 'new-expense') {
      return <NewExpense {...startApp.parameters} />
    }

    if (startApp?.command === 'view-expense') {
      return <Detail {...startApp.parameters} />
    }

    return <div>Invalid launch params</div>
  }, [lp, startApp]);

  return (
    <LaunchParamsContext.Provider value={lp}>
      {component}
    </LaunchParamsContext.Provider>
  )
}

export default App;
